import {useCallback, useEffect, useState} from "react";
import Api from "../../helpers/api";
import {filterShippingMethods} from "../../helpers/utils";
import {LegacyStack, Select, TextField} from "@shopify/polaris";

export function ShippingMethodSelector({
    customer,
    country,
    state,
    shippingMethod,
    setShippingMethod,
    disabled = false,
}) {
    const [shippingMethods, setShippingMethods] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        Promise
            .all([
                Api.getShippingMethods().then(results => results.data),
            ])
            .then(([
               shippingMethodsData,
           ]) => {
                setShippingMethods(filterShippingMethods(country, state, shippingMethodsData));
                if (customer && customer.data.shipping_method)
                    setShippingMethod({
                        name: customer.data.shipping_method?.name ?? '',
                        price: customer.data.shipping_method?.price ?? '0',
                        key: customer.data.shipping_method?.shopify_rate_id ?? customer.data.shipping_method?.key //fallback for old values
                    });
            })
            .finally(() => setLoading(false));
    }, []);

    const handleShippingMethodChange = useCallback((key) => {
        if (!key || key.length == 0) {
            setShippingMethod({
                name: '',
                price: '',
                key: '',
            });
            return;
        }

        let method = null;
        shippingMethods.forEach((item) => {
            if (item.key == key)
                method = item;
        });

        if (!method) {
            setShippingMethod({
                name: '',
                price: '',
                key: '',
            });
            return;
        }

        setShippingMethod({
            name: method.name,
            price: method.price,
            key: method.key,
        });
    }, [shippingMethod, shippingMethods]);

    const changeCustomShippingMethod = useCallback((value, id) => {
        setShippingMethod({
            ...shippingMethod,
            [id]: value,
        });
    }, [shippingMethod]);


    return (<>
        <Select label="Shipping Method"
                requiredIndicator={true}
                options={[
                    { label: '--Select Shipping Method--', value: '' },
                    ...(shippingMethods.map((method) => {
                        return {
                            label: method.label,
                            value: method.key + ''
                        }
                    }))
                ]}
                onChange={handleShippingMethodChange}
                value={shippingMethod?.key + ''}
                id="shipping_method"
                disabled={disabled || loading}
        />

        { shippingMethod?.key == 'custom' && (
            <LegacyStack distribution={"fillEvenly"}>
                <TextField autoComplete={'on'} requiredIndicator={true} label="Shipping Method Name" id="name" value={shippingMethod.name} onChange={changeCustomShippingMethod} disabled={disabled} />
                <TextField autoComplete={'on'} requiredIndicator={true} label="Shipping Method Price" id="price" type={"number"} min={0} step={1.0} value={shippingMethod.price.toString()} onChange={changeCustomShippingMethod} disabled={disabled} />
            </LegacyStack>
        ) }
    </>);
}
